var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "b-card",
        [
          _c(
            "b-card-body",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "d-flex justify-content-end",
                      attrs: { md: "12" },
                    },
                    [
                      _vm.IsAdmin()
                        ? _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.addModal",
                                  modifiers: { addModal: true },
                                },
                              ],
                              attrs: { variant: "primary" },
                            },
                            [
                              _c("feather-icon", {
                                staticClass: "mr-50",
                                attrs: { icon: "PlusIcon" },
                              }),
                              _vm._v(" Import Timesheet "),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-modal",
                              rawName: "v-b-modal.modal-add-timesheet",
                              modifiers: { "modal-add-timesheet": true },
                            },
                          ],
                          staticClass: "ml-2",
                          attrs: { variant: "primary" },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "PlusIcon" },
                          }),
                          _vm._v(" Add Timesheet "),
                        ],
                        1
                      ),
                      _c(
                        "b-modal",
                        {
                          ref: "addTimesheet",
                          attrs: {
                            id: "modal-add-timesheet",
                            "ok-only": "",
                            "ok-title": "Add",
                            centered: "",
                            size: "lg",
                            title: "Add Timesheet",
                            "hide-footer": true,
                          },
                          on: { hide: _vm.resetForm },
                        },
                        [
                          _c("validation-observer", {
                            ref: "formAddTimesheet",
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var invalid = ref.invalid
                                  return [
                                    _c(
                                      "b-form",
                                      {
                                        on: {
                                          submit: function ($event) {
                                            $event.preventDefault()
                                            return _vm.addTimesheet($event)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { md: "12" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "Date",
                                                      "label-for": "date",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Date",
                                                        vid: "date",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-datepicker",
                                                                  {
                                                                    attrs: {
                                                                      id: "date",
                                                                      placeholder:
                                                                        "Date",
                                                                      state:
                                                                        errors.length >
                                                                        0
                                                                          ? false
                                                                          : null,
                                                                      max: _vm.today,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .date,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.formData,
                                                                            "date",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "formData.date",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm.IsAdmin()
                                              ? _c(
                                                  "b-col",
                                                  { attrs: { sm: "12" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label: "Employee",
                                                          "label-for":
                                                            "employee",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "validation-provider",
                                                          {
                                                            attrs: {
                                                              rules: "required",
                                                              name: "Employee",
                                                              vid: "employee",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    return [
                                                                      _c(
                                                                        "b-form-select",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              options:
                                                                                _vm.employeeOptions,
                                                                              state:
                                                                                errors.length >
                                                                                0
                                                                                  ? false
                                                                                  : null,
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .formData
                                                                                  .employeeID,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.formData,
                                                                                    "employeeID",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "formData.employeeID",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "small",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              errors[0]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "12" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "Approver",
                                                      "label-for":
                                                        "mc-approver",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Approver",
                                                        vid: "Approver",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-select",
                                                                  {
                                                                    attrs: {
                                                                      id: "mc-approver",
                                                                      options:
                                                                        _vm.userList,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .approverID,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.formData,
                                                                            "approverID",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "formData.approverID",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "12" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "Start Time",
                                                      "label-for": "startTime",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Start Time",
                                                        vid: "start Time",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-timepicker",
                                                                  {
                                                                    attrs: {
                                                                      id: "startTime",
                                                                      min: new Date(),
                                                                      locale:
                                                                        "en",
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.calculateHoursWorked,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .startTime,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.formData,
                                                                            "startTime",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "formData.startTime",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "12" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "End Time",
                                                      "label-for": "endTime",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "End Time",
                                                        vid: "end Time",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-timepicker",
                                                                  {
                                                                    attrs: {
                                                                      id: "endTime",
                                                                      min: new Date(),
                                                                      locale:
                                                                        "en",
                                                                    },
                                                                    on: {
                                                                      change:
                                                                        _vm.calculateHoursWorked,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .endTime,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.formData,
                                                                            "endTime",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "formData.endTime",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "12" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "Total Hours",
                                                      "label-for": "totalHours",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Total Hours",
                                                        vid: "total hours",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-input",
                                                                  {
                                                                    attrs: {
                                                                      name: "totalHours",
                                                                      placeholder:
                                                                        "Total Hours",
                                                                      disabled:
                                                                        "",
                                                                      state:
                                                                        errors.length >
                                                                        0
                                                                          ? false
                                                                          : null,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .hoursWorked,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.formData,
                                                                            "hoursWorked",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "formData.hoursWorked",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "12" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "Description",
                                                      "label-for":
                                                        "description",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "Description",
                                                        vid: "description",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-textarea",
                                                                  {
                                                                    attrs: {
                                                                      name: "description",
                                                                      placeholder:
                                                                        "Description",
                                                                      state:
                                                                        errors.length >
                                                                        0
                                                                          ? false
                                                                          : null,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .formData
                                                                          .taskDescription,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.formData,
                                                                            "taskDescription",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "formData.taskDescription",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-end",
                                                attrs: { md: "12" },
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      type: "submit",
                                                      disabled: _vm.submitting,
                                                      variant: "primary",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.addTimesheet()
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm.submitting
                                                      ? _c("b-spinner", {
                                                          attrs: { small: "" },
                                                        })
                                                      : _vm._e(),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.submitting
                                                            ? "Submitting..."
                                                            : "Submit"
                                                        )
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant: "primary",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.closeModal()
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-2",
                          attrs: { variant: "outline-success" },
                          on: { click: _vm.exportToCSV },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "DownloadIcon" },
                          }),
                          _vm._v(" Export to Excel "),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-modal",
                {
                  attrs: {
                    id: "addModal",
                    title: "Import Timesheet",
                    "cancel-title": "Close",
                    "hide-footer": "",
                    centered: "",
                  },
                  model: {
                    value: _vm.showAddModal,
                    callback: function ($$v) {
                      _vm.showAddModal = $$v
                    },
                    expression: "showAddModal",
                  },
                },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.ImportTimesheet($event)
                        },
                      },
                    },
                    [
                      _c("b-row", [
                        _c(
                          "div",
                          { staticClass: "m-4" },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "Upload File",
                                  "label-for": "file-input ",
                                },
                              },
                              [
                                _c("b-form-file", {
                                  attrs: {
                                    id: "file-input",
                                    placeholder:
                                      "Choose a file or drop it here...",
                                    "drop-placeholder": "Drop file here...",
                                  },
                                  model: {
                                    value: _vm.file,
                                    callback: function ($$v) {
                                      _vm.file = $$v
                                    },
                                    expression: "file",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("b-card-text", { staticClass: "my-1" }, [
                              _vm._v(" Selected file: "),
                              _c("strong", [
                                _vm._v(
                                  _vm._s(
                                    _vm.file
                                      ? _vm.file.name
                                      : "No file selected"
                                  )
                                ),
                              ]),
                            ]),
                          ],
                          1
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-end" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mr-2",
                              attrs: { variant: "secondary" },
                              on: {
                                click: function ($event) {
                                  return _vm.closeImportmodal()
                                },
                              },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _c(
                            "b-button",
                            {
                              attrs: { type: "button", variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.ImportTimesheet()
                                },
                              },
                            },
                            [_vm._v("Submit")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "b-row",
                { staticClass: "justify-content-between" },
                [
                  _c(
                    "b-col",
                    {
                      staticClass: "my-1",
                      attrs: { cols: " 12", md: "2", sm: "2" },
                    },
                    [
                      _c(
                        "b-form-group",
                        { staticClass: "mb-0" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "d-inline-block text-sm-left mr-50",
                            },
                            [_vm._v("Per page")]
                          ),
                          _c("b-form-select", {
                            staticClass: "w-50",
                            attrs: {
                              id: "perPageSelect",
                              size: "sm",
                              options: _vm.pageOptions,
                            },
                            model: {
                              value: _vm.perPage,
                              callback: function ($$v) {
                                _vm.perPage = $$v
                              },
                              expression: "perPage",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass: "text-right my-2",
                      attrs: { cols: " 12", md: "2", sm: "2" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "ml-2",
                          attrs: { size: "sm", variant: "outline-secondary" },
                          on: { click: _vm.clearFilters },
                        },
                        [_vm._v(" Clear Filters ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _vm.mainLoading
                        ? _c(
                            "div",
                            { staticClass: "d-flex justify-content-center" },
                            [
                              _c("b-spinner", {
                                staticStyle: { width: "3rem", height: "3rem" },
                                attrs: {
                                  variant: "success",
                                  label: "Spinning",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.mainLoading
                        ? _c("b-table", {
                            attrs: {
                              striped: "",
                              hover: "",
                              responsive: "",
                              "per-page": _vm.perPage,
                              "current-page": _vm.currentPage,
                              items: _vm.filteredTimesheets(),
                              fields: _vm.timesheet_fields,
                              "sort-by": _vm.sortBy,
                              "sort-desc": _vm.sortDesc,
                              "sort-direction": _vm.sortDirection,
                            },
                            on: {
                              "update:sortBy": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sort-by": function ($event) {
                                _vm.sortBy = $event
                              },
                              "update:sortDesc": function ($event) {
                                _vm.sortDesc = $event
                              },
                              "update:sort-desc": function ($event) {
                                _vm.sortDesc = $event
                              },
                              filtered: _vm.onFiltered,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "head(employeeName)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [_vm._v("Employee")]),
                                          _c("b-form-input", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              placeholder: "Filter by Name",
                                              size: "sm",
                                            },
                                            model: {
                                              value: _vm.filters.employeeName,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "employeeName",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filters.employeeName",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(moduleType)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [_vm._v("Module")]),
                                          _c("b-form-select", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              options: [
                                                { value: null, text: "All" },
                                              ].concat(_vm.timesheetModules),
                                              size: "sm",
                                            },
                                            model: {
                                              value: _vm.filters.module,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "module",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.module",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(hoursWorked)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [_vm._v("Total Hours")]),
                                          _c("b-form-input", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              placeholder: "Filter by Hours",
                                              size: "sm",
                                            },
                                            model: {
                                              value: _vm.filters.hoursWorked,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "hoursWorked",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.hoursWorked",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(status)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [_vm._v("Status")]),
                                          _c(
                                            "b-form-select",
                                            {
                                              staticClass: "mt-1",
                                              attrs: { size: "sm" },
                                              model: {
                                                value: _vm.filters.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.filters,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression: "filters.status",
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                { domProps: { value: null } },
                                                [_vm._v("All")]
                                              ),
                                              _vm._l(
                                                _vm.timesheetStatus,
                                                function (status) {
                                                  return _c(
                                                    "option",
                                                    {
                                                      key: status.value,
                                                      domProps: {
                                                        value: status.value,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(status.text) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(taskDescription)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [_vm._v("Comment")]),
                                          _c("b-form-input", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              placeholder: "Filter by Comment",
                                              size: "sm",
                                            },
                                            model: {
                                              value:
                                                _vm.filters.taskDescription,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "taskDescription",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filters.taskDescription",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "head(date)",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c("span", [_vm._v("Submitted On")]),
                                          _c("b-form-datepicker", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              placeholder: "Select Date",
                                              size: "sm",
                                              "date-format-options": {
                                                year: "numeric",
                                                month: "2-digit",
                                                day: "2-digit",
                                              },
                                            },
                                            on: {
                                              input: function ($event) {
                                                _vm.currentPage = 1
                                              },
                                            },
                                            model: {
                                              value: _vm.filters.date,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "date",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.date",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(date)",
                                  fn: function (data) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatDateDDMMMYYYY(
                                              data.item.date
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "cell(actions)",
                                  fn: function (data) {
                                    return [
                                      _c(
                                        "b-dropdown",
                                        {
                                          staticClass: "m-1",
                                          attrs: {
                                            variant: "link",
                                            "toggle-class": "p-0",
                                            "no-caret": "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "button-content",
                                                fn: function () {
                                                  return [
                                                    _c("feather-icon", {
                                                      staticClass:
                                                        "align-middle text-body",
                                                      attrs: {
                                                        icon: "MoreVerticalIcon",
                                                        size: "16",
                                                      },
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _vm.checkPermissions(data.item)
                                            ? _c(
                                                "b-dropdown-item",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.timesheetAction(
                                                        "APPROVED",
                                                        data.item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("feather-icon", {
                                                    attrs: {
                                                      icon: "CheckIcon",
                                                    },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "align-middle ml-50",
                                                    },
                                                    [_vm._v("Approve")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.checkPermissions(data.item)
                                            ? _c(
                                                "b-dropdown-item",
                                                {
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.timesheetAction(
                                                        "REJECTED",
                                                        data.item
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("feather-icon", {
                                                    attrs: { icon: "XIcon" },
                                                  }),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "align-middle ml-50",
                                                    },
                                                    [_vm._v("Reject")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "b-dropdown-item",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  return _vm.viewTimesheet(
                                                    data.item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("feather-icon", {
                                                attrs: { icon: "EyeIcon" },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "align-middle ml-50",
                                                },
                                                [_vm._v("View")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1025381611
                            ),
                          })
                        : _vm._e(),
                      _c(
                        "b-modal",
                        {
                          ref: "viewTimesheet",
                          attrs: {
                            id: "modal-view-timesheet",
                            "ok-only": "",
                            "ok-title": "View",
                            centered: "",
                            size: "lg",
                            title: "View timesheet",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c(
                            "b-form",
                            [
                              _c(
                                "b-row",
                                [
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Date",
                                            "label-for": "date",
                                          },
                                        },
                                        [
                                          _c("b-form-datepicker", {
                                            attrs: {
                                              id: "date",
                                              placeholder: "Date",
                                              disabled: "",
                                            },
                                            model: {
                                              value: _vm.timesheetId.date,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.timesheetId,
                                                  "date",
                                                  $$v
                                                )
                                              },
                                              expression: "timesheetId.date",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { sm: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Employee",
                                            "label-for": "employee",
                                          },
                                        },
                                        [
                                          _c("b-form-select", {
                                            attrs: {
                                              options: _vm.employeeListOptions,
                                              disabled: true,
                                            },
                                            model: {
                                              value: _vm.timesheetId.employeeID,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.timesheetId,
                                                  "employeeID",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "timesheetId.employeeID",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Total Hours",
                                            "label-for": "totalHours",
                                          },
                                        },
                                        [
                                          _c("b-form-input", {
                                            attrs: {
                                              name: "totalHours",
                                              placeholder: "Total Hours",
                                              readonly: "",
                                            },
                                            model: {
                                              value:
                                                _vm.timesheetId.hoursWorked,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.timesheetId,
                                                  "hoursWorked",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "timesheetId.hoursWorked",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-col",
                                    { attrs: { md: "12" } },
                                    [
                                      _c(
                                        "b-form-group",
                                        {
                                          attrs: {
                                            label: "Description",
                                            "label-for": "description",
                                          },
                                        },
                                        [
                                          _c("b-form-textarea", {
                                            attrs: {
                                              name: "description",
                                              placeholder: "Description",
                                              readonly: "",
                                            },
                                            model: {
                                              value:
                                                _vm.timesheetId.taskDescription,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.timesheetId,
                                                  "taskDescription",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "timesheetId.taskDescription",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "b-modal",
                        {
                          ref: "editTimesheet",
                          attrs: {
                            id: "modal-edit-timesheet",
                            "ok-only": "",
                            "ok-title": "Edit",
                            centered: "",
                            size: "lg",
                            title: "Edit timesheet",
                            "hide-footer": true,
                          },
                        },
                        [
                          _c("validation-observer", {
                            ref: "formEditTimesheet",
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (ref) {
                                  var invalid = ref.invalid
                                  return [
                                    _c(
                                      "b-form",
                                      {
                                        on: {
                                          submit: function ($event) {
                                            $event.preventDefault()
                                            return _vm.saveEditedTimesheet(
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              { attrs: { md: "12" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "Date",
                                                      "label-for": "date",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "date",
                                                        vid: "date",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-datepicker",
                                                                  {
                                                                    attrs: {
                                                                      id: "date",
                                                                      placeholder:
                                                                        "Date",
                                                                      state:
                                                                        errors.length >
                                                                        0
                                                                          ? false
                                                                          : null,
                                                                      max: _vm.today,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .editFormData
                                                                          .date,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.editFormData,
                                                                            "date",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "editFormData.date",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm.IsAdmin()
                                              ? _c(
                                                  "b-col",
                                                  { attrs: { sm: "12" } },
                                                  [
                                                    _c(
                                                      "b-form-group",
                                                      {
                                                        attrs: {
                                                          label: "Employee",
                                                          "label-for":
                                                            "employee",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "validation-provider",
                                                          {
                                                            attrs: {
                                                              rules: "required",
                                                              name: "employee",
                                                              vid: "employee",
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "default",
                                                                  fn: function (
                                                                    ref
                                                                  ) {
                                                                    var errors =
                                                                      ref.errors
                                                                    return [
                                                                      _c(
                                                                        "b-form-select",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              options:
                                                                                _vm.employeeOptions,
                                                                              state:
                                                                                errors.length >
                                                                                0
                                                                                  ? false
                                                                                  : null,
                                                                            },
                                                                          model:
                                                                            {
                                                                              value:
                                                                                _vm
                                                                                  .editFormData
                                                                                  .employeeID,
                                                                              callback:
                                                                                function (
                                                                                  $$v
                                                                                ) {
                                                                                  _vm.$set(
                                                                                    _vm.editFormData,
                                                                                    "employeeID",
                                                                                    $$v
                                                                                  )
                                                                                },
                                                                              expression:
                                                                                "editFormData.employeeID",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c(
                                                                        "small",
                                                                        {
                                                                          staticClass:
                                                                            "text-danger",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              errors[0]
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "12" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "Total Hours",
                                                      "label-for": "totalHours",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "total hours",
                                                        vid: "total hours",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-input",
                                                                  {
                                                                    attrs: {
                                                                      name: "totalHours",
                                                                      placeholder:
                                                                        "Total Hours",
                                                                      disabled:
                                                                        "",
                                                                      state:
                                                                        errors.length >
                                                                        0
                                                                          ? false
                                                                          : null,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .editFormData
                                                                          .hoursWorked,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.editFormData,
                                                                            "hoursWorked",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "editFormData.hoursWorked",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "12" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "Start Date",
                                                      "label-for": "startDate",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "startDate",
                                                        vid: "startDate",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-datepicker",
                                                                  {
                                                                    attrs: {
                                                                      id: "startDate",
                                                                      placeholder:
                                                                        "Start Date",
                                                                      state:
                                                                        errors.length >
                                                                        0
                                                                          ? false
                                                                          : null,
                                                                      max: _vm.today,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .editFormData
                                                                          .startDate,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.editFormData,
                                                                            "startDate",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "editFormData.startDate",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "12" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "End Date",
                                                      "label-for": "endDate",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "endDate",
                                                        vid: "endDate",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-datepicker",
                                                                  {
                                                                    attrs: {
                                                                      id: "endDate",
                                                                      placeholder:
                                                                        "End Date",
                                                                      state:
                                                                        errors.length >
                                                                        0
                                                                          ? false
                                                                          : null,
                                                                      max: _vm.today,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .editFormData
                                                                          .endDate,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.editFormData,
                                                                            "endDate",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "editFormData.endDate",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              { attrs: { md: "12" } },
                                              [
                                                _c(
                                                  "b-form-group",
                                                  {
                                                    attrs: {
                                                      label: "Description",
                                                      "label-for":
                                                        "description",
                                                    },
                                                  },
                                                  [
                                                    _c("validation-provider", {
                                                      attrs: {
                                                        rules: "required",
                                                        name: "description",
                                                        vid: "description",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function (ref) {
                                                              var errors =
                                                                ref.errors
                                                              return [
                                                                _c(
                                                                  "b-form-textarea",
                                                                  {
                                                                    attrs: {
                                                                      name: "description",
                                                                      placeholder:
                                                                        "Description",
                                                                      state:
                                                                        errors.length >
                                                                        0
                                                                          ? false
                                                                          : null,
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm
                                                                          .editFormData
                                                                          .taskDescription,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            _vm.editFormData,
                                                                            "taskDescription",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "editFormData.taskDescription",
                                                                    },
                                                                  }
                                                                ),
                                                                _c(
                                                                  "small",
                                                                  {
                                                                    staticClass:
                                                                      "text-danger",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        errors[0]
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            },
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    }),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-end",
                                                attrs: { md: "12" },
                                              },
                                              [
                                                _c(
                                                  "b-button",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      type: "submit",
                                                      variant: "primary",
                                                    },
                                                    on: {
                                                      click:
                                                        _vm.saveEditedTimesheet,
                                                    },
                                                  },
                                                  [_vm._v(" Save ")]
                                                ),
                                                _c(
                                                  "b-button",
                                                  {
                                                    attrs: {
                                                      variant: "primary",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.$bvModal.hide(
                                                          "modal-edit-timesheet"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Cancel")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("b-pagination", {
                        staticClass: "mt-2",
                        attrs: {
                          "total-rows": _vm.totalRows,
                          "per-page": _vm.perPage,
                          align: "center",
                          size: "sm",
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                      _c("b-form-group", [
                        _vm._v(
                          " Showing " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? _vm.perPage * (_vm.currentPage - 1) + 1
                                : 0
                            ) +
                            " to " +
                            _vm._s(
                              _vm.totalRows > 0
                                ? Math.min(
                                    _vm.perPage * _vm.currentPage,
                                    _vm.totalRows
                                  )
                                : 0
                            ) +
                            " of " +
                            _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                            " entries "
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }